import React, { useContext, useMemo, useCallback } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Wrapper = styled.div`
  &:hover {
    ${({ $clickable }) => $clickable && 'text-decoration: underline'};
  }
`;

const DateRenderer = ({ rowData: { subRows, projectId, branchId, date }, columnData }) => {
  const { dateFormat } = useContext(ConfigContext);
  const { accountId, clickableDate } = columnData || {};

  const allowClickOnDate = useMemo(() => clickableDate && accountId && projectId, [
    accountId,
    clickableDate,
    projectId
  ]);

  const link = useMemo(() => allowClickOnDate && `${accountId}/scheduling/branch/${branchId}/project/${projectId}`, [
    accountId,
    allowClickOnDate,
    branchId,
    projectId
  ]);

  const onClick = useCallback(() => (link ? window.open(link, '_blank') : undefined), [link]);

  if (subRows || !date || !moment(date).isValid()) {
    return <></>;
  }

  return (
    <Wrapper onClick={onClick} $clickable={!!allowClickOnDate}>
      {moment(date).format(`${dateFormat}, ddd`)}
    </Wrapper>
  );
};

export default DateRenderer;
